// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2hEnV","header":"PatientBlock_header__14VOX","label":"PatientBlock_label__1l4nZ","option":"PatientBlock_option__2yei2"};